import React from 'react'
import { Section } from '@/components/shared/section/Section'
import { env } from '@/utils/constants/env'

export const KpiGRD: React.FC = () => {
  return (
    <Section title="Dashboard Pemantauan KPI GRD">
      <div className="flex flex-col items-center gap-1 p-10">
        <iframe
          data-testid="dashboard-iframe"
          title="KPI GRD"
          src={env.iFrameMetabaseKpiGRD}
          width="100%"
          height="600"
          style={{ border: 'none' }}
        />
      </div>
    </Section>
  )
}
